import script from "./RouteList.vue?vue&type=script&setup=true&lang=js"
export * from "./RouteList.vue?vue&type=script&setup=true&lang=js"

import "./RouteList.vue?vue&type=style&index=0&id=753a3814&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-753a3814"]])

export default __exports__